<div
  class="combobox-container"
  [class.open]="isOpen"
  [class.disabled]="disabled"
  [class.has-value]="hasSelectedValue"
  [ngClass]="customClass"
  (appClickOutside)="onClickOutside()"
>
  <div
    class="combobox-trigger"
    [attr.id]="id"
    [attr.tabindex]="disabled ? -1 : 0"
    (click)="toggleDropdown()"
    (keydown)="onTriggerKeydown($event)"
  >
    <span
      class="combobox-value"
      [class.placeholder-text]="!hasSelectedValue"
      [title]="hasSelectedValue ? selectedLabel : ''"
    >
      {{ selectedLabel }}
    </span>

    <div class="combobox-actions">
      @if (clearable && hasSelectedValue && !disabled) {
        <button
          type="button"
          class="btn-clear"
          (click)="clearSelection($event)"
          [attr.aria-label]="
            'GENERAL_OUTREACH_FORM.OPTIONS.CLEAR_SELECTION' | translate
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            class="action-icon"
          >
            <path
              d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
            />
          </svg>
        </button>
      }

      <span class="chevron-wrapper">
        <svg
          class="chevron-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M6 8L10 12L14 8"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </div>
  </div>

  @if (isOpen) {
    <div class="combobox-dropdown" role="presentation">
      <div class="combobox-search-box">
        <svg
          class="search-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M14 14L18 18M16 9A7 7 0 1 1 2 9a7 7 0 0 1 14 0Z"
            stroke="currentColor"
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <input
          #searchInput
          type="text"
          class="combobox-search-input"
          [placeholder]="effectiveSearchPlaceholder"
          [ngModel]="searchQuery"
          (ngModelChange)="onSearchChange($event)"
          (keydown)="onSearchKeydown($event)"
          (click)="$event.stopPropagation()"
          autocomplete="off"
          spellcheck="false"
        />

        @if (searchQuery) {
          <button
            type="button"
            class="btn-search-clear"
            (click)="clearSearch($event)"
            aria-label="Clear query"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              class="action-icon"
            >
              <path
                d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
              />
            </svg>
          </button>
        }
      </div>

      <div #optionsList class="combobox-options-list" role="listbox">
        @if (filteredOptions.length === 0) {
          <div class="combobox-empty">
            {{ effectiveEmptyText }}
          </div>
        } @else {
          @for (
            option of filteredOptions;
            track getOptionValue(option);
            let idx = $index
          ) {
            <div
              class="combobox-option-item"
              [class.selected]="isSelected(option)"
              [class.highlighted]="idx === highlightedIndex"
              [attr.aria-selected]="isSelected(option)"
              role="option"
              tabindex="0"
              (click)="selectOption(option, $event)"
              (keydown.enter)="selectOption(option, $event)"
              (mouseenter)="highlightedIndex = idx"
            >
              <span class="option-text">{{ getOptionLabel(option) }}</span>

              @if (isSelected(option)) {
                <svg
                  class="check-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              }
            </div>
          }
        }
      </div>
    </div>
  }
</div>
